import { z } from "zod";
import { TaskAttemptVersion } from "@remi/enums/task-attempt-version";
import { TaskType } from "@remi/enums/task-type";

const InsuranceEstimateCreatedV1DataSchema = z.object({
  version: z.literal(TaskAttemptVersion.v1),
  estimateId: z.string(),
});
export type InsuranceEstimateCreatedV1Data = z.infer<typeof InsuranceEstimateCreatedV1DataSchema>;

const InsuranceEstimateCreatedDataSchema = z.discriminatedUnion("version", [InsuranceEstimateCreatedV1DataSchema]);

export const InsuranceEstimateCreatedTaskAttemptSchema = z.object({
  type: z.literal(TaskType.INSURANCE_ESTIMATE_CREATED),
  data: InsuranceEstimateCreatedDataSchema,
});

export type InsuranceEstimateCreatedTaskAttempt = z.infer<typeof InsuranceEstimateCreatedTaskAttemptSchema>;
